export default [
  {
    path: '/products/retail-catalog/items',
    name: 'products-retail-items-index',
    component: () => import('@/views/product/retail-catalog/RetailItemList.vue'),
    meta: {
      title: 'Retail Items',
      pageTitle: 'Products & Services',
      breadcrumb: [
        {
          text: 'Retail Items',
          active: true,
        },
      ],
      resource: 'RetailItem',
      action: 'read',
    },
  },
  {
    path: '/products/retail-catalog/items/create',
    name: 'products-retail-items-create',
    component: () => import('@/views/product/retail-catalog/RetailItemCreate.vue'),
    meta: {
      title: 'Create New Retail Item',
      pageTitle: 'Products & Services',
      navActiveLink: 'products-retail-items-index',
      breadcrumb: [
        {
          text: 'Retail Items',
          to: '/products/retail-catalog/items',
        },
        {
          text: 'Create New Retail Item',
          active: true,
        },
      ],
      resource: 'RetailItem',
      action: 'create',
    },
  },
  {
    path: '/products/retail-catalog/items/:id/update',
    name: 'products-retail-items-edit',
    component: () => import('@/views/product/retail-catalog/RetailItemEdit.vue'),
    meta: {
      title: 'Edit Retail Item',
      pageTitle: 'Products & Services',
      navActiveLink: 'products-retail-items-index',
      breadcrumb: [
        {
          text: 'Retail Items',
          to: '/products/retail-catalog/items',
        },
        {
          text: 'Edit Retail Item',
          active: true,
        },
      ],
      resource: 'RetailItem',
      action: 'update',
    },
  },
  {
    path: '/products/retail-catalog/coupons',
    name: 'products-retail-coupons-index',
    component: () => import('@/views/product/retail-catalog/RetailCouponList.vue'),
    meta: {
      title: 'Retail Coupons',
      pageTitle: 'Products & Services',
      breadcrumb: [
        {
          text: 'Retail Coupons',
          active: true,
        },
      ],
      resource: 'RetailCoupon',
      action: 'read',
    },
  },
  {
    path: '/products/retail-catalog/coupons/create',
    name: 'products-retail-coupons-create',
    component: () => import('@/views/product/retail-catalog/RetailCouponCreate.vue'),
    meta: {
      title: 'Create new Retail Coupon',
      pageTitle: 'Products & Services',
      navActiveLink: 'products-retail-coupons-index',
      breadcrumb: [
        {
          text: 'Retail Coupons',
          to: '/products/retail-catalog/coupons',
        },
        {
          text: 'Create new Retail Coupon',
          active: true,
        },
      ],
      resource: 'RetailCoupon',
      action: 'create',
    },
  },
  {
    path: '/products/retail-catalog/coupons/:id/show',
    name: 'products-retail-coupons-show',
    component: () => import('@/views/product/retail-catalog/RetailCouponDetails.vue'),
    meta: {
      title: 'Retail Coupon Detail',
      pageTitle: 'Products & Services',
      navActiveLink: 'products-retail-coupons-index',
      breadcrumb: [
        {
          text: 'Retail Coupons',
          to: '/products/retail-catalog/coupons',
        },
        {
          text: 'Retail Coupon Detail',
          active: true,
        },
      ],
      resource: 'RetailCoupon',
      action: 'show',
    },
  },
  {
    path: '/products/retail-catalog/coupons/:id/update',
    name: 'products-retail-coupons-edit',
    component: () => import('@/views/product/retail-catalog/RetailCouponEdit.vue'),
    meta: {
      title: 'Edit Retail Coupon',
      pageTitle: 'Products & Services',
      navActiveLink: 'products-retail-coupons-index',
      breadcrumb: [
        {
          text: 'Retail Coupons',
          to: '/products/retail-catalog/coupons',
        },
        {
          text: 'Edit Retail Coupon',
          active: true,
        },
      ],
      resource: 'RetailCoupon',
      action: 'update',
    },
  },
  {
    path: '/products/promotions',
    name: 'products-promotions-index',
    component: () => import('@/views/product/promotions/PromotionList.vue'),
    meta: {
      title: 'Promotions and Discounts',
      pageTitle: 'Products & Services',
      breadcrumb: [
        {
          text: 'Promotions and Discounts',
          active: true,
        },
      ],
      resource: 'Promotion',
      action: 'read',
    },
  },
  {
    path: '/products/promotions/create',
    name: 'products-promotions-create',
    component: () => import('@/views/product/promotions/PromotionCreate.vue'),
    meta: {
      title: 'Create New Promotion and Discount',
      pageTitle: 'Products & Services',
      navActiveLink: 'products-promotions-index',
      breadcrumb: [
        {
          text: 'Promotions and Discounts',
          to: '/products/promotions',
        },
        {
          text: 'Create New Promotion and Discount',
          active: true,
        },
      ],
      resource: 'Promotion',
      action: 'create',
    },
  },
  {
    path: '/products/promotions/:id/show',
    name: 'products-promotions-show',
    component: () => import('@/views/product/promotions/PromotionDetails.vue'),
    meta: {
      title: 'Promotion Detail',
      pageTitle: 'Products & Services',
      navActiveLink: 'products-promotions-index',
      breadcrumb: [
        {
          text: 'Promotions and Discounts',
          to: '/products/promotions',
        },
        {
          text: 'Promotion Detail',
          active: true,
        },
      ],
      resource: 'Promotion',
      action: 'show',
    },
  },
  {
    path: '/products/promotions/:id/update',
    name: 'products-promotions-edit',
    component: () => import('@/views/product/promotions/PromotionEdit.vue'),
    meta: {
      title: 'Edit Promotion and Discount',
      pageTitle: 'Products & Services',
      navActiveLink: 'products-promotions-index',
      breadcrumb: [
        {
          text: 'Promotions and Discounts',
          to: '/products/promotions',
        },
        {
          text: 'Edit Promotion and Discount',
          active: true,
        },
      ],
      resource: 'Promotion',
      action: 'update',
    },
  },
  {
    path: '/products/locations',
    name: 'products-locations-index',
    component: () => import('@/views/product/locations/LocationList.vue'),
    meta: {
      title: 'Locations',
      pageTitle: 'Products & Services',
      breadcrumb: [
        {
          text: 'Locations',
          active: true,
        },
      ],
      resource: 'SuiteLocation',
      action: 'read',
    },
  },
  {
    path: '/products/locations/create',
    name: 'products-locations-create',
    component: () => import('@/views/product/locations/LocationCreate.vue'),
    meta: {
      title: 'Create New Location',
      pageTitle: 'Products & Services',
      navActiveLink: 'products-locations-index',
      breadcrumb: [
        {
          text: 'Locations',
          to: '/products/locations',
        },
        {
          text: 'Create New Location',
          active: true,
        },
      ],
      resource: 'SuiteLocation',
      action: 'create',
    },
  },
  {
    path: '/products/locations/:id/show',
    name: 'products-locations-show',
    component: () => import('@/views/product/locations/LocationDetails.vue'),
    meta: {
      title: 'Location Detail',
      pageTitle: 'Products & Services',
      navActiveLink: 'products-locations-index',
      breadcrumb: [
        {
          text: 'Locations',
          to: '/products/locations',
        },
        {
          text: 'Location Detail',
          active: true,
        },
      ],
      resource: 'SuiteLocation',
      action: 'show',
    },
  },
  {
    path: '/products/locations/:id/update',
    name: 'products-locations-edit',
    component: () => import('@/views/product/locations/LocationEdit.vue'),
    meta: {
      title: 'Edit Location',
      pageTitle: 'Products & Services',
      navActiveLink: 'products-locations-index',
      breadcrumb: [
        {
          text: 'Locations',
          to: '/products/locations',
        },
        {
          text: 'Edit Location',
          active: true,
        },
      ],
      resource: 'SuiteLocation',
      action: 'update',
    },
  },
  {
    path: '/products/areas',
    name: 'products-areas-index',
    component: () => import('@/views/product/areas/AreaList.vue'),
    meta: {
      title: 'Areas',
      pageTitle: 'Products & Services',
      breadcrumb: [
        {
          text: 'Areas',
          active: true,
        },
      ],
      resource: 'SuiteArea',
      action: 'read',
    },
  },
  {
    path: '/products/areas/create',
    name: 'products-areas-create',
    component: () => import('@/views/product/areas/AreaCreate.vue'),
    meta: {
      title: 'Create New Area',
      pageTitle: 'Products & Services',
      navActiveLink: 'products-areas-index',
      breadcrumb: [
        {
          text: 'Areas',
          to: '/products/areas',
        },
        {
          text: 'Create New Area',
          active: true,
        },
      ],
      resource: 'SuiteArea',
      action: 'create',
    },
  },
  {
    path: '/products/areas/:id/show',
    name: 'products-areas-show',
    component: () => import('@/views/product/areas/AreaDetails.vue'),
    meta: {
      title: 'Area Detail',
      pageTitle: 'Products & Services',
      navActiveLink: 'products-areas-index',
      breadcrumb: [
        {
          text: 'Areas',
          to: '/products/areas',
        },
        {
          text: 'Area Detail',
          active: true,
        },
      ],
      resource: 'SuiteArea',
      action: 'show',
    },
  },
  {
    path: '/products/areas/:id/update',
    name: 'products-areas-edit',
    component: () => import('@/views/product/areas/AreaEdit.vue'),
    meta: {
      title: 'Edit Area',
      pageTitle: 'Products & Services',
      navActiveLink: 'products-areas-index',
      breadcrumb: [
        {
          text: 'Areas',
          to: '/products/areas',
        },
        {
          text: 'Edit Area',
          active: true,
        },
      ],
      resource: 'SuiteArea',
      action: 'update',
    },
  },

  {
    path: '/products/suites',
    name: 'products-suites-index',
    component: () => import('@/views/product/suites/SuiteList.vue'),
    meta: {
      title: 'Suites',
      pageTitle: 'Products & Services',
      breadcrumb: [
        {
          text: 'Suites & Lots',
          active: true,
        },
      ],
      resource: 'Suite',
      action: 'read',
    },
  },
  {
    path: '/products/suites/create',
    name: 'products-suites-create',
    component: () => import('@/views/product/suites/SuiteCreate.vue'),
    meta: {
      title: 'Create New Suite',
      pageTitle: 'Products & Services',
      navActiveLink: 'products-suites-index',
      breadcrumb: [
        {
          text: 'Suites & Lots',
          to: '/products/suites',
        },
        {
          text: 'Create New Suite',
          active: true,
        },
      ],
      resource: 'Suite',
      action: 'create',
    },
  },
  {
    path: '/products/suites/:id/show',
    name: 'products-suites-show',
    component: () => import('@/views/product/suites/SuiteDetails.vue'),
    meta: {
      title: 'Suite Detail',
      pageTitle: 'Products & Services',
      navActiveLink: 'products-suites-index',
      breadcrumb: [
        {
          text: 'Suites & Lots',
          to: '/products/suites',
        },
        {
          text: 'Suite Detail',
          active: true,
        },
      ],
      resource: 'Suite',
      action: 'show',
    },
  },
  {
    path: '/products/suites/:id/update',
    name: 'products-suites-edit',
    component: () => import('@/views/product/suites/SuiteEdit.vue'),
    meta: {
      title: 'Edit Suite',
      pageTitle: 'Products & Services',
      navActiveLink: 'products-suites-index',
      breadcrumb: [
        {
          text: 'Suites & Lots',
          to: '/products/suites',
        },
        {
          text: 'Edit Suite',
          active: true,
        },
      ],
      resource: 'Suite',
      action: 'update',
    },
  },
  {
    path: '/products/lots/:id/show',
    name: 'products-lots-show',
    component: () => import('@/views/product/lots/LotDetails.vue'),
    meta: {
      title: 'Lot Detail',
      pageTitle: 'Products & Services',
      navActiveLink: 'products-suites-index',
      breadcrumb: [
        {
          text: 'Suites & Lots',
          to: '/products/suites',
        },
        {
          text: 'Lot Detail',
          active: true,
        },
      ],
      resource: 'Lot',
      action: 'show',
    },
  },
  {
    path: '/products/categories',
    name: 'products-categories-index',
    component: () => import('@/views/product/categories/CategoryList.vue'),
    meta: {
      title: 'Product Categories',
      pageTitle: 'Products & Services',
      breadcrumb: [
        {
          text: 'Product Categories',
          active: true,
        },
      ],
      resource: 'ProductCategory',
      action: 'read',
    },
  },
  {
    path: '/products/categories/create',
    name: 'products-categories-create',
    component: () => import('@/views/product/categories/CategoryCreate.vue'),
    meta: {
      title: 'Create New Category',
      pageTitle: 'Products & Services',
      navActiveLink: 'products-categories-index',
      breadcrumb: [
        {
          text: 'Product Categories',
          to: '/products/categories',
        },
        {
          text: 'Create New Category',
          active: true,
        },
      ],
      resource: 'ProductCategory',
      action: 'create',
    },
  },
  {
    path: '/products/categories/:id/show',
    name: 'products-categories-show',
    component: () => import('@/views/product/categories/CategoryDetail.vue'),
    meta: {
      title: 'Category Detail',
      pageTitle: 'Products & Services',
      navActiveLink: 'products-categories-index',
      breadcrumb: [
        {
          text: 'Product Categories',
          to: '/products/categories',
        },
        {
          text: 'Category Detail',
          active: true,
        },
      ],
      resource: 'ProductCategory',
      action: 'show',
    },
  },
  {
    path: '/products/categories/:id/update',
    name: 'products-categories-edit',
    component: () => import('@/views/product/categories/CategoryEdit.vue'),
    meta: {
      title: 'Edit Category',
      pageTitle: 'Products & Services',
      navActiveLink: 'products-categories-index',
      breadcrumb: [
        {
          text: 'Product Categories',
          to: '/products/categories',
        },
        {
          text: 'Edit Category',
          active: true,
        },
      ],
      resource: 'ProductCategory',
      action: 'update',
    },
  },
  {
    path: '/products/codes',
    name: 'products-codes-index',
    component: () => import('@/views/product/codes/CodeList.vue'),
    meta: {
      title: 'Product Codes',
      pageTitle: 'Products & Services',
      breadcrumb: [
        {
          text: 'Product Codes',
          active: true,
        },
      ],
      resource: 'ProductCode',
      action: 'read',
    },
  },
  {
    path: '/products/codes/create',
    name: 'products-codes-create',
    component: () => import('@/views/product/codes/CodeCreate.vue'),
    meta: {
      title: 'Create New Code',
      pageTitle: 'Products & Services',
      navActiveLink: 'products-codes-index',
      breadcrumb: [
        {
          text: 'Product Codes',
          to: '/products/codes',
        },
        {
          text: 'Create New Code',
          active: true,
        },
      ],
      resource: 'ProductCode',
      action: 'create',
    },
  },
  {
    path: '/products/codes/:id/show',
    name: 'products-codes-show',
    component: () => import('@/views/product/codes/CodeDetail.vue'),
    meta: {
      title: 'Code Detail',
      pageTitle: 'Products & Services',
      navActiveLink: 'products-codes-index',
      breadcrumb: [
        {
          text: 'Product Codes',
          to: '/products/codes',
        },
        {
          text: 'Code Detail',
          active: true,
        },
      ],
      resource: 'ProductCode',
      action: 'show',
    },
  },
  {
    path: '/products/codes/:id/update',
    name: 'products-codes-edit',
    component: () => import('@/views/product/codes/CodeEdit.vue'),
    meta: {
      title: 'Edit Code',
      pageTitle: 'Products & Services',
      navActiveLink: 'products-codes-index',
      breadcrumb: [
        {
          text: 'Product Codes',
          to: '/products/codes',
        },
        {
          text: 'Edit Code',
          active: true,
        },
      ],
      resource: 'ProductCode',
      action: 'update',
    },
  },
  {
    path: '/products/catalog',
    name: 'products-catalog-index',
    component: () => import('@/views/product/catalog/CatalogList.vue'),
    meta: {
      title: 'Product Catalog',
      pageTitle: 'Products & Services',
      breadcrumb: [
        {
          text: 'Product Catalog',
          active: true,
        },
      ],
      resource: 'ProductCatalog',
      action: 'read',
    },
  },
  {
    path: '/products/catalog/:id/show',
    name: 'products-catalog-show',
    component: () => import('@/views/product/catalog/CatalogDetail.vue'),
    meta: {
      title: 'Catalog Detail',
      pageTitle: 'Products & Services',
      navActiveLink: 'products-catalog-index',
      breadcrumb: [
        {
          text: 'Product Catalog',
          to: '/products/catalog',
        },
        {
          text: 'Catalog Detail',
          active: true,
        },
      ],
      resource: 'ProductCatalog',
      action: 'show',
    },
  },
  {
    path: '/products/catalog/:id/update',
    name: 'products-catalog-edit',
    component: () => import('@/views/product/catalog/CatalogEdit.vue'),
    meta: {
      title: 'Edit Catalog',
      pageTitle: 'Products & Services',
      navActiveLink: 'products-catalog-index',
      breadcrumb: [
        {
          text: 'Product Catalog',
          to: '/products/catalog',
        },
        {
          text: 'Edit Catalog',
          active: true,
        },
      ],
      resource: 'ProductCatalog',
      action: 'update',
    },
  },
  {
    path: '/products/need-type/:id/update',
    name: 'products-need-type-edit',
    component: () => import('@/views/product/needTypes/NeedTypeEdit.vue'),
    meta: {
      title: 'Edit Need Type',
      pageTitle: 'Products & Services',
      navActiveLink: 'products-codes-index',
      breadcrumb: [
        {
          text: 'Product Codes',
          to: '/products/codes',
        },
        {
          text: 'Edit Need Type',
          active: true,
        },
      ],
      resource: 'ProductNeedType',
      action: 'update',
    },
  },
  {
    path: '/products/schemes/:type',
    name: 'products-schemes-index',
    component: () => import('@/views/product/schemes/SchemeList.vue'),
    meta: {
      title: 'Entitlement Schemes',
      pageTitle: 'Products & Services',
      breadcrumb: [
        {
          text: 'Entitlement Schemes',
          active: true,
        },
      ],
      resource: 'EntitlementScheme',
      action: 'read',
    },
  },
  {
    path: '/products/schemes/new/create',
    name: 'products-schemes-create',
    component: () => import('@/views/product/schemes/SchemeCreate.vue'),
    meta: {
      title: 'Create New Scheme',
      pageTitle: 'Products & Services',
      navActiveLink: 'products-schemes-index',
      breadcrumb: [
        {
          text: 'Entitlement Schemes',
          to: '/products/schemes/all-scheme',
        },
        {
          text: 'Create New Scheme',
          active: true,
        },
      ],
      resource: 'EntitlementScheme',
      action: 'create',
    },
  },
  {
    path: '/products/schemes/:id/show',
    name: 'products-schemes-show',
    component: () => import('@/views/product/schemes/SchemeDetail.vue'),
    meta: {
      title: 'Scheme Detail',
      pageTitle: 'Products & Services',
      navActiveLink: 'products-schemes-index',
      breadcrumb: [
        {
          text: 'Entitlement Schemes',
          to: '/products/schemes/all-scheme',
        },
        {
          text: 'Scheme Detail',
          active: true,
        },
      ],
      resource: 'EntitlementScheme',
      action: 'show',
    },
  },
  {
    path: '/products/schemes/:id/update',
    name: 'products-schemes-edit',
    component: () => import('@/views/product/schemes/SchemeEdit.vue'),
    meta: {
      title: 'Edit Scheme',
      pageTitle: 'Products & Services',
      navActiveLink: 'products-schemes-index',
      breadcrumb: [
        {
          text: 'Entitlement Schemes',
          to: '/products/schemes/all-scheme',
        },
        {
          text: 'Edit Scheme',
          active: true,
        },
      ],
      resource: 'EntitlementScheme',
      action: 'update',
    },
  },
  {
    path: '/products/scheme-items/create',
    name: 'products-scheme-items-create',
    component: () => import('@/views/product/scheme-items/ItemCreate.vue'),
    meta: {
      title: 'Create New Scheme Item',
      pageTitle: 'Products & Services',
      navActiveLink: 'products-schemes-index',
      breadcrumb: [
        {
          text: 'Entitlement Schemes',
          to: '/products/schemes/all-scheme',
        },
        {
          text: 'Creating Entitlement Item to be Issued',
          active: true,
        },
      ],
      resource: 'EntitlementScheme',
      action: 'create',
    },
  },
  {
    path: '/products/scheme-items/:id/update',
    name: 'products-scheme-items-edit',
    component: () => import('@/views/product/scheme-items/ItemEdit.vue'),
    meta: {
      title: 'Edit Scheme Item',
      pageTitle: 'Products & Services',
      navActiveLink: 'products-schemes-index',
      breadcrumb: [
        {
          text: 'Entitlement Schemes',
          to: '/products/schemes/all-scheme',
        },
        {
          text: 'Editing Entitlement Item to be Issued',
          active: true,
        },
      ],
      resource: 'EntitlementScheme',
      action: 'update',
    },
  },
]
